module.exports = __webpack_public_path__ + "static/media/priority_low.b9654354.svg";